
/* injects from baggage-loader */

'use strict';

import bg from '_images/stages/bg.png';

import $ from 'jquery';

export default class DialogStagesController {
  constructor($log, $rootScope, $timeout, Session,$state) {
    'ngInject';
    this.$log = $log;
    this.$state = $state;
    this.bg = bg;

    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.Session = Session;
  }

  $onInit() {
      this.stages = this.Session.get().stages;
      
      this.$rootScope.$bg2 = true
      
      this.$timeout(this.bindCarousel.bind(this));
  }

  $onDestroy() {
      this.$rootScope.$bg2 = false
  }

  toHome(){
        this.$state.go('main');
        this.ok();
  }

  bindCarousel(){
      // Initialize Carousel
      $('.stages-carousel').slick({
          infinite: false,
          draggable: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
      });

      let stagesComplete = this.Session.getTaskOne();

      if(stagesComplete === 3){
        $('.stages-carousel').slick('slickGoTo', 1);
      }

  }

  ok(){
    this.modalInstance.close(true);
  }

  cancel(){
    this.modalInstance.dismiss('cancel');
  }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/stages/stages.controller.js